import { Loan } from '../../loan/shared/loan.model';
import { Location } from '../../location/shared/location.model';

export class Request {
  loan: Loan;
  location: Location;
}
